
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorPointingHand as ObiCursorPointingHandElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-pointing-hand.js';
 
 
 

 
 export const ObiCursorPointingHand = createComponent({
   react: React,
   tagName: 'obi-cursor-pointing-hand',
   elementClass: ObiCursorPointingHandElement,
   events: {
     
   }
  });
 
 